import { RefObject, useRef, useState } from 'react';
import classNames from 'classnames';
import Tooltip from '../Tooltip';
import styles from './styles.module.scss';

function getOffset(ref: RefObject<HTMLDivElement>, position: ITooltipWrapperProps['tooltipPosition']) {
  if (!ref.current) return 0;

  if (position === 'left' || position === 'right') return ref.current.offsetHeight / 2;
  return ref.current.offsetWidth / 2;
}

export interface ITooltipWrapperProps {
  tooltipText: string;
  tooltipPosition: 'top' | 'left' | 'bottom' | 'right';
  children?: React.ReactNode;
  className?: string;
}

const TooltipWrapper = ({ tooltipText, tooltipPosition, children, className }: ITooltipWrapperProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div
      aria-label={tooltipText}
      className={styles.wrapper}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Tooltip
        position={tooltipPosition}
        offset={getOffset(contentRef, tooltipPosition)}
        visible={showTooltip}
        text={tooltipText}
      />
      <div className={classNames(styles.content, className)} ref={contentRef}>
        {children}
      </div>
    </div>
  );
};

export default TooltipWrapper;
